import * as Constants from '../constants';

const initialState = {
  uploadedImages: [],
  s3UploadLinks: [],
};
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case Constants.GET_PRESCRIPTION_IMAGES_START:
      return Object.assign(state, { data: state.data, action: action, loading: true });
    case Constants.GET_PRESCRIPTION_IMAGES_SUCCESS:
      return Object.assign(state, { data: action.data, action: action, loading: false });
    case Constants.GET_PRESCRIPTION_IMAGES_FAILURE:
      return Object.assign(state, { data: action.data, action: action, loading: false });
    case Constants.SAVE_NEW_PRESCRIPTION:
      return Object.assign(state, { uploadedImages: [...state.uploadedImages, action.data] });
    case Constants.DELETE_NEW_PRESCRIPTION:
      let updatedImages = state.uploadedImages.filter(({ id }) => {
        return id !== action.data;
      });
      return Object.assign(state, { uploadedImages: updatedImages });
    case Constants.GET_S3_UPLOAD_URL_SUCCESS:
      return Object.assign(state, { s3UploadLinks: action.data.urls || action.data.data || []});
    case Constants.CUSTOMER_INFO:
      return {
        uploadedImages: [],
        s3UploadLinks: [],
      };
    default:
      return state;
  }
}
